import React from "react";

import HeaderContainer from "../../components/header/HeaderContainer";
import HeaderTitle from "../../components/header/HeaderTitle";
import HeaderContentSmall from "../../components/header/HeaderContentSmall";
import SubHeading from "../../components/inner/venderProduct/SubHeading";
import ImageTextPanel from "../../components/inner/technologies/ImageTextPanel";
import { useLanguage } from "../../context/LanguageContext";
import { siteCopy } from "../../i18n/landingCopy";

import TelematicsImage01 from "../../assets/technologies/telematicsImage02.png";
import TelematicsImage03 from "../../assets/technologies/telematicsImage03.png";
import styled from "styled-components";

const Telematics = () => {
  const { language } = useLanguage();
  const copy =
    siteCopy[language]?.pages?.technologies?.telematics ||
    siteCopy.en.pages.technologies.telematics;

  const renderLines = (lines = []) =>
    lines.map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < lines.length - 1 && <br />}
      </React.Fragment>
    ));

  return (
    <>
      <HeaderContainer>
        <HeaderTitle>{copy.title}</HeaderTitle>

        <div style={{ height: "60px" }}></div>

        <HeaderContentSmall>{renderLines(copy.introParagraph)}</HeaderContentSmall>

        <div
          style={{
            width: "100%",
            height: "auto",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            paddingBottom: 30,
          }}
        >
          <LeftSideImageView src={TelematicsImage01} />
          <RigthSideContentView>
            <p style={{ lineHeight: 1.6 }}>{renderLines(copy.detailParagraphs?.[0] || [])}</p>

            <p style={{ lineHeight: 1.6 }}>{renderLines(copy.detailParagraphs?.[1] || [])}</p>

            <p style={{ lineHeight: 1.6 }}>{renderLines(copy.detailParagraphs?.[2] || [])}</p>
          </RigthSideContentView>
        </div>

        <SubHeading>{copy.solutionTitle}</SubHeading>

        <ImageTextPanel
          Image={TelematicsImage03}
          Title={copy.solution.title}
          Link={copy.solution.link}
          Text={<>{renderLines(copy.solution.text)}</>}
        />
      </HeaderContainer>
    </>
  );
};

const LeftSideImageView = styled.img`
  width: 43%;
  object-fit: contain;

  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    display: none;
  }

  /* 450px 미만 */
  @media (max-width: 449px) {
    display: none;
  }
`;

const RigthSideContentView = styled.div`
  width: 54%;

  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    width: 100%;
  }

  /* 450px 미만 */
  @media (max-width: 449px) {
    width: 100%;
  }
`;

export default Telematics;
